// AutoTextField.js
import React, { useEffect, useState } from "react";
import { TextField, Autocomplete } from "@mui/material";
import { AppWord } from "../value/AppConst";

function findItem(list, value, valueKey) {
    if(!list) return null;
    for(let i=0; i<list.length; i++) {
        if(list[i][valueKey] === value) {
            return list[i];
        }
    }
    return null;
}

export default function AutoTextField({
    dict, // {id, label, ...., valueKey, labelKey}
    value,
    list,
    onChange,
    onSelectRecord,
    disabled,
    size,
    style,
    onInputChange,
    hideLabel,
    listBoxProps,
}) {
    const [itemFound, setItemFound] = useState(null);
    //const [slotProps, setSlotProps] = useState(undefined);

    const valueKey = dict.valueKey || dict.id;
    const labelKey = dict.labelKey || 'label';

    /* useEffect(() => {
        if(listBoxProps) setSlotProps({listbox: listBoxProps});
        else setSlotProps(undefined);
    }, [listBoxProps]); */

    useEffect(()=>{
        if(value !== undefined && value !== null && value !== '') {
            const item = findItem(list, value, valueKey);
            //if(item) setItemFound(item);
            setItemFound(item);
        }
        else {
            setItemFound(null);
        }
    }, [list, value]);

    const getOptionLabel = (option) => {
        if(dict.getOptionLabel) return dict.getOptionLabel(option);
        return option[labelKey];
    };

    const onChangeValue = (e, value) => {
        if(value) {
            setItemFound(value);
            onChange(dict.id, value[valueKey]);
            if(onSelectRecord) onSelectRecord(value);
        }
    }

    const onChangeText = (e, value, reason) => {
        if(onInputChange) onInputChange(e, value, reason);
    };

    const newStyle = style ? {...style} : {};
    if(!newStyle.minWidth) newStyle.minWidth = 100;
    if(!newStyle.fontSize) newStyle.fontSize = '0.85rem';
    if(!newStyle.backgroundColor) newStyle.backgroundColor = 'white';

    return(
        <Autocomplete
            options={list}
            size={size || AppWord.SMALL}
            getOptionLabel={getOptionLabel}
            onChange={onChangeValue}
            onInputChange={onChangeText}
            value={itemFound}
            disabled={disabled}
            renderInput={
                (params) =>
                    <TextField {...params} label={hideLabel ? undefined : dict.label}
                        style={{fontSize: newStyle.fontSize}}
                    />
            }
            isOptionEqualToValue={(option, value) => option[valueKey] === value[valueKey]}
            style={newStyle}
            disablePortal
            ListboxProps={listBoxProps || undefined}
            /* slotProps={slotProps} */
            sx={{
                '& + .MuiAutocomplete-popper .MuiAutocomplete-option .MuiAutocomplete-input .MuiAutocomplete-inputRoot': {
                    fontSize: '0.85rem',
                },
            }}
        />
    );
}